import { Injectable } from "@angular/core";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExportService{
    constructor(){}

    public exportAsExcelFile(json: any[], excelFileName: string):void{
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        // let numberOfRow = json.length;
        // let numberOfColumn= 0;
        // numberOfColumn = this.countProperties(json);   
        // var fmt = "0.00";  
        // var range = { s: {r:0, c:1}, e: {r:numberOfColumn-1, c:numberOfRow-1} };
        // var ws = XLSX.utils.aoa_to_sheet(json);
        // for(var R = range.s.r; R <= range.e.r; ++R) {
        //     for(var C = range.s.c; C <= range.e.c; ++C) {
        //       var cell_address = {c:C, r:R};
        //       var cell_ref = ws[XLSX.utils.encode_cell({r:R,c:C})];
        //       if(!cell_ref || cell_ref.t != 'n') continue; // only format numeric cells
        //       cell_ref.z = fmt;
        //     }
        //   }
        const workbook: XLSX.WorkBook = {Sheets: {'data':worksheet}, SheetNames:['data']};
        const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    // countProperties(arrayJson):number {
    //     let count = 0;
    //     let _element;
    //     arrayJson.forEach(element => {
    //         if (_element && _element !== element)
    //             return count;
    //         _element=element
    //         Object.keys(element).forEach(property =>{
    //             count++;
    //         })
    //     });
    //     return count;
    // }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob ([buffer],{
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_'+new Date().getTime()+  EXCEL_EXTENSION);
    }

}